export default "__VITE_ASSET__Cn70ZhTm__"